import React, { useState } from "react";
import { Tab, Nav, Card } from 'react-bootstrap';
import { RcsTemplateTable, SMSTemplate, TemplateTable } from "components/Tables";
import { useLocation } from "react-router-dom";

export default () => {
    const location = useLocation();
    const defaultTab = 'SMS';
    const tabFromState = location.state?.tab || defaultTab;

    const [activeKey, setActiveKey] = useState(tabFromState);

    return (
        <>

            <Tab.Container
                defaultActiveKey={activeKey} onChange={setActiveKey}
            >
                <Card className="p-2">

                    <Nav fill variant="pills" className="flex-lg-nowrap gap-2">
                        <Nav.Item>
                            <Nav.Link eventKey="SMS">
                                SMS
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="WhatsApp">
                                WhatsApp
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="RCS">
                                RCS
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Card>

                <Tab.Content className="mt-0 mt-lg-3">
                    <Tab.Pane eventKey="SMS">
                        <SMSTemplate />
                    </Tab.Pane>

                    <Tab.Pane eventKey="WhatsApp">
                        <TemplateTable />
                    </Tab.Pane>

                    <Tab.Pane eventKey="RCS">
                       <RcsTemplateTable />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </>
    );
};
